
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  disabled = false,
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900';
  
  const variants = {
    primary: 'bg-neutral-900 text-white hover:bg-neutral-700 disabled:bg-neutral-400 disabled:cursor-not-allowed',
    secondary: 'bg-neutral-100 text-neutral-900 hover:bg-neutral-200 disabled:bg-neutral-50 disabled:text-neutral-400 disabled:cursor-not-allowed',
    outline: 'border border-neutral-300 text-neutral-700 hover:bg-neutral-50 disabled:border-neutral-200 disabled:text-neutral-400 disabled:cursor-not-allowed'
  };

  const sizes = {
    sm: 'px-3 sm:px-4 py-2 text-sm rounded-lg',
    md: 'px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg',
    lg: 'px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg rounded-xl'
  };

  return (
    <button
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
